import {stringToBoolean} from "../shared/helpers";

export default {
  is_on_prem: stringToBoolean(process.env.REACT_APP_IS_ON_PREM),
  is_clone: stringToBoolean(process.env.REACT_APP_IS_CLONE),
  react_app_auth_provider: process.env.REACT_APP_AUTH_PROVIDER,
  react_app_auth0_audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};
